var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_558_61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 4H17.0001V2C17.0001 1.46957 16.7894 0.960859 16.4143 0.585786C16.0393 0.210714 15.5306 0 15.0001 0L9.00012 0C8.46969 0 7.96098 0.210714 7.58591 0.585786C7.21084 0.960859 7.00012 1.46957 7.00012 2V4H2.00012V6H4.00012V21C4.00012 21.7956 4.31619 22.5587 4.8788 23.1213C5.44141 23.6839 6.20447 24 7.00012 24H17.0001C17.7958 24 18.5588 23.6839 19.1214 23.1213C19.6841 22.5587 20.0001 21.7956 20.0001 21V6H22.0001V4ZM9.00012 2H15.0001V4H9.00012V2ZM18.0001 21C18.0001 21.2652 17.8948 21.5196 17.7072 21.7071C17.5197 21.8946 17.2653 22 17.0001 22H7.00012C6.73491 22 6.48055 21.8946 6.29302 21.7071C6.10548 21.5196 6.00012 21.2652 6.00012 21V6H18.0001V21Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 9.99939H9V17.9994H11V9.99939Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 9.99939H13.0002V17.9994H15.0003V9.99939Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_558_61"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.43678f4505a46d8e036c6f83ee941fcb.svg";
export { ForwardRef as ReactComponent };